import {ComponentFactoryResolver, ComponentRef, Injectable, ViewContainerRef} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {FormComponent} from './model/form-component';
import {DynamicComponent} from "./dynamic-component";
import {COMPONENT_TYPES_REGISTRY} from "./model/registry";

@Injectable()
export class DynamicComponentBuilder {

    constructor(private factoryResolver: ComponentFactoryResolver) {
    }

    public build(component: FormComponent, data: any, formGroup: FormGroup, viewContainerRef: ViewContainerRef): ComponentRef<any> {
        if (!component) {
            console.error('Component not defined');
            return;
        }
        if (!component.type) {
            console.error('Component type not defined' + component.id);
            return;
        }
        const compType = COMPONENT_TYPES_REGISTRY.get(component.type).type;
        if (!compType) {
            console.error('Component type [%s] not found in the list of module components: %s', component.type, Array.from(COMPONENT_TYPES_REGISTRY.keys()).toString());
            return;
        }
        const factory = this.factoryResolver.resolveComponentFactory(compType);
        if (!factory) {
            console.error('Component not defined: ' + compType);
            return;
        }
        viewContainerRef.clear();

        console.log('Creating component:');
        const componentRef = viewContainerRef.createComponent(factory);
        this.initInputData(component, data, formGroup, componentRef);
        return componentRef;
    }

    private initInputData(component: FormComponent, data: any, formGroup: FormGroup, compRef: ComponentRef<any>): void {
        (compRef.instance as DynamicComponent).component = component;
        (compRef.instance as DynamicComponent).data = data;
        (compRef.instance as DynamicComponent).formGroup = formGroup;
    }

}
